export const CommunicationValidation = (formData) => {
    const errors = {};
    if (!formData.dt_Created || !formData.dt_Created.trim()) {
        errors.dt_Created = 'This field is required';
    }
    if (!formData.vc_Description || formData.vc_Description === "0") {
        errors.vc_Description = 'This field is required';
    }
    if (formData.snt_CommunicationType === 1 || formData.snt_CommunicationType === "1") {
        if (!isValidEmail(formData.vc_From)) {
            errors.vc_From = 'Please enter a valid email address';
        }
        if (!isValidEmail(formData.vc_To)) {
            errors.vc_To = 'Please enter a valid email address';
        }
        if (formData.vc_CC) {
            if (!isValidEmail(formData.vc_CC)) {
                errors.vc_CC = 'Please enter a valid email address';
            }
        }
    }
    debugger;
    if (formData.StartTime && formData.AppointmentEndTime) {
        const startTime = new Date(`1970-01-01T${formData.StartTime}`);
        const endTime = new Date(`1970-01-01T${formData.AppointmentEndTime}`);
    
        if (endTime <= startTime) {
            errors.AppointmentEndTime = 'End Time must be greater than Start Time';
        }
    }

    return errors;
};
const isValidEmail = (email) => {
    // You can implement a regex or use a library like validator.js to validate email format
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};
